"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractEmissionValue = exports.transformToDisplay = exports.isVehicleHybrid = void 0;
const avp_models_1 = require("@oneaudi/avp-models");
const propertyIsNotUndefined = (keyValuePair) => !!keyValuePair[1];
const byCycleDescFuelAscCategoryAsc = (a, b) => a.cycle.localeCompare(b.cycle, 'en') ||
    a.fuel.localeCompare(b.fuel, 'en') ||
    a.category.localeCompare(b.category, 'en');
const showOnlyChangedCycleAndFuel = (item, index, items) => {
    if (index === 0)
        return item;
    const cycleHasChanged = items[index - 1].cycle !== item.cycle;
    const fuelHasChanged = items[index - 1].fuel !== item.fuel;
    return {
        ...item,
        fuel: cycleHasChanged || fuelHasChanged ? item.fuel : ''
    };
};
const isVehicleHybrid = (data) => {
    const fuelKeys = new Set(Object.keys(data.fuels));
    return fuelKeys.has('PETROL') && fuelKeys.has('ELECTRICAL');
};
exports.isVehicleHybrid = isVehicleHybrid;
const transformToDisplay = (data, market, brand) => {
    const isGermanAudiMarket = market === avp_models_1.Market.DEU && brand === avp_models_1.Brand.AUDI;
    const values = {
        eec: data.eec,
        items: Object.entries(data.fuels ? data.fuels : data).flatMap(([fuel, cae]) => Object.entries(cae)
            .filter(propertyIsNotUndefined)
            .flatMap(([category, cycles]) => Object.entries(cycles)
            .map(([cycle, cycleData]) => ({
            hasNedc: data.fuels[fuel].consumption?.nedc,
            hasWltp: data.fuels[fuel].consumption?.wltp,
            unit: cycleData ? cycleData.unit : '',
            value: cycleData ? cycleData.subcycles.combined : NaN,
            fuel,
            category,
            cycle: cycle.toUpperCase()
        }))
            .filter(item => item.category !== 'consumptionEmptyBattery') // This category is only important for PkwEnVkV
        ))
    };
    // Due to legal requirements only within the AUDI DEU market missing NEFZ values need to be displayed with a "-" symbol
    if (isGermanAudiMarket) {
        const itemsWithNedc = values.items.filter(item => item.cycle === 'NEDC');
        const itemsMissingNedc = values.items.filter(item => item.cycle === 'WLTP' &&
            item.category !== 'range' &&
            !itemsWithNedc.find(value => value.fuel === item.fuel && value.category === item.category));
        itemsMissingNedc.forEach(item => values.items.push({
            category: item.category,
            cycle: 'NEDC',
            fuel: item.fuel,
            unit: item.unit,
            value: '-',
            hasNedc: undefined,
            hasWltp: undefined
        }));
    }
    values.items = values.items.sort(byCycleDescFuelAscCategoryAsc).map(showOnlyChangedCycleAndFuel);
    return values;
};
exports.transformToDisplay = transformToDisplay;
const extractEmissionValue = (consumptionAndEmissionData) => {
    if (!consumptionAndEmissionData) {
        return undefined;
    }
    const fuelKeys = Object.keys(consumptionAndEmissionData?.fuels);
    if (fuelKeys.length === 1) {
        return consumptionAndEmissionData?.fuels[fuelKeys[0]].emission?.wltp?.subcycles?.combined;
    }
    const fuelWithEmission = fuelKeys.filter(fuel => fuel !== 'ELECTRICAL').pop();
    if (!fuelWithEmission) {
        return undefined;
    }
    return consumptionAndEmissionData?.fuels[fuelWithEmission].emission?.wltp?.subcycles?.combined;
};
exports.extractEmissionValue = extractEmissionValue;
